/**
 * Shared search matcher for merge-tag pickers (toolbar dropdown, inline popover,
 * attribute panel). Matches the query against the display label AND the field
 * key + full dotted key, so natural queries like "beds"/"baths" find fields
 * whose label is phrased differently (e.g. listing.beds → "Bedrooms").
 *
 * NOTE: keys are used for matching only — callers still render the label, so
 * raw keys are never shown to the user.
 *
 * @param label           Display label (from getFieldLabel)
 * @param fieldKey        Field key within the group (e.g. "beds")
 * @param fullKey         Full dotted key (e.g. "listing.beds")
 * @param normalizedQuery Already lowercased + trimmed search query
 * @returns true if the query is empty or matches any of label/fieldKey/fullKey
 */
export function matchesMergeTagQuery(
	label: string,
	fieldKey: string,
	fullKey: string,
	normalizedQuery: string,
): boolean {
	if (!normalizedQuery) return true;
	const haystack = `${label} ${fieldKey} ${fullKey}`.toLowerCase();
	return haystack.includes(normalizedQuery);
}
